import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CopyClipboardDirective} from './copy-clipboard.directive';
import {SwiperDirective} from './swiper.directive';
import {PullToRefreshDirective} from './pull-to-refresh.directive';
import {HomeTabSwipeDirective} from './home-tab-swipe.directive';
import {MobileStackTransitionDirective} from './mobile-stack-transition.directive';



@NgModule({
  declarations: [
    CopyClipboardDirective,
    PullToRefreshDirective,
    HomeTabSwipeDirective,
    MobileStackTransitionDirective
    // SwiperDirective
  ],
  exports: [
    // SwiperDirective,
    CopyClipboardDirective,
    PullToRefreshDirective,
    HomeTabSwipeDirective,
    MobileStackTransitionDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
